export default __webpack_public_path__ + "static/media/agua-contaminada.b47b925e.jpg";